import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  DxPopupModule,
  DxValidationGroupModule,
  DxValidationGroupComponent,
} from 'devextreme-angular';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { GpdRoleSelectComponent } from 'src/app/components/gpd-role-select/gpd-role-select.component';
import { ContactsAddPersonInlineComponent } from 'src/app/components/contacts-add-person-inline/contacts-add-person-inline.component';
import { ContactsAddCompanyInlineComponent } from 'src/app/components/contacts-add-company-inline/contacts-add-company-inline.component';
import { ContactService } from 'src/app/services/contact.service';
import { AppGlobals } from 'src/app/app.globals';

@Component({
    selector: 'app-project-new-contact-modal',
    imports: [
        CommonModule,
        DxPopupModule,
        DxValidationGroupModule,
        GpdButtonComponent,
        GpdRoleSelectComponent,
        ContactsAddPersonInlineComponent,
        ContactsAddCompanyInlineComponent,
    ],
    templateUrl: './project-new-contact-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-new-contact-modal.component.css']
})
export class ProjectNewContactModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() projectId!: number;
  @Input() type: 'person' | 'company' = 'person';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onSaved = new EventEmitter<void>();

  @ViewChild(ContactsAddPersonInlineComponent) personForm?: ContactsAddPersonInlineComponent;
  @ViewChild(ContactsAddCompanyInlineComponent) companyForm?: ContactsAddCompanyInlineComponent;
  @ViewChild('roleValidationGroup') roleValidationGroup?: DxValidationGroupComponent;

  role = '';

  private saving = false;

  constructor(private contactService: ContactService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.role = '';
      this.saving = false;
    }
  }

  save(): void {
    // Validate BOTH the inline contact form and the role together so every error shows at once.
    // (short-circuiting on the role would hide the inline form's required-field messages.)
    const inlineForm = this.type === 'person' ? this.personForm?.personForm : this.companyForm?.companyForm;
    const formValid = inlineForm?.instance?.validate()?.isValid !== false;
    const roleValid = this.roleValidationGroup?.instance?.validate()?.isValid !== false;

    if (!formValid || !roleValid) {
      return;
    }

    // Both valid — the inline form creates the contact and emits onContactCreated with the new record.
    if (this.type === 'person') {
      this.personForm?.handleSubmitButton(null);
    } else {
      this.companyForm?.handleSubmitButton(null);
    }
  }

  onContactCreated(e: any): void {
    const contact = e?.data;
    if (!contact?.id || this.saving) {
      return;
    }
    this.saving = true;

    this.contactService
      .addProjectContact({
        ProjectId: this.projectId,
        Contacts: [{ ContactId: contact.id, ContactType: this.type, Role: this.role.trim() }],
      })
      .then((result) => {
        this.saving = false;
        if (result?.hasError) {
          AppGlobals.ShowErrorMessage(result.feedback);
          return;
        }
        this.onSaved.emit();
        this.close();
      })
      .catch((error) => {
        this.saving = false;
        AppGlobals.ShowErrorMessage(error);
      });
  }

  close(): void {
    this.visible = false;
    this.role = '';
    this.visibleChange.emit(false);
  }
}
